import Vue from 'vue';

// 自定義指令，點擊其他區域，關閉下拉選單
Vue.directive("click-outside", {
    // el就是綁定指令的元素，bindings.expression就是動態參數這裡是hide，vnode是綁定指令的元素的虛擬節點，vnode.context就是節點所在的vm實例
    bind(el, bindings, vnode) {
        el.handle = e => {
            // 點擊的是 綁定指令元素麼 不是就觸發 參數傳進來的函數
            let body = e.target.tagName === 'BODY';

            if (!body && !el.contains(e.target)) {
                let method = bindings.expression;
                vnode.context[method]();
            }
        };

        document.addEventListener("click", el.handle);
    },
    unbind(el) {
        // 相關事件移除
        document.removeEventListener("click", el.handle);
    }
});

// 自定義指令，傳入權限，元素是否渲染
Vue.directive('auth', {
  //當被綁定的元素插入到 DOM 中時……
  inserted: (el, binding, vnode) => {
    const route = vnode.context.$route;
    const meta = route.meta;
    const value = binding.value;

    if (meta.permission.length > 0) {
      if (!meta.permission.includes(value)) {
        el.parentNode.removeChild(el);
      }
    } else {
      el.parentNode.removeChild(el);
    }
  }
});



// WEBPACK FOOTER //
// ./src/models/HELPERS/directive.js